import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@sundae/ui-toolkit";
import { memo } from "react";
import { Trans } from "react-i18next";
const ErrorDetailsMessage = memo(({ toggleCollapsible }) => {
    return (_jsx(Text, { tag: "div", children: _jsxs(Trans, { i18nKey: "detailsToggle", ns: "error-fallback", children: ["To see what data this error report contains,", _jsx(Text, { className: "cursor-pointer", onClick: toggleCollapsible, tag: "span", variant: "primary", children: "click here" }), "."] }) }));
});
export default ErrorDetailsMessage;
//# sourceMappingURL=ErrorDetailsMessage.trans.js.map